import axios from 'axios'
import { routesRegistration as routes } from '../routes'
import { ENROLL_MFA,
    ENROLL_MFA_ERROR,
    ENROLL_MFA_SUCCESS,
    FETCH_DATA_ERROR,
    FETCH_DATA_SUCCESS,
    INIT,
    INIT_AUTHENTICATORS,
    INIT_AUTHENTICATORS_ERROR,
    INIT_AUTHENTICATORS_SUCCESS,
    INIT_ENROLL_FACTOR,
    INIT_ENROLL_FACTOR_ERROR,
    INIT_ENROLL_FACTOR_SUCCESS,
    INIT_SEND_CHALLENGE,
    INIT_SEND_CHALLENGE_SUCCESS,
    INIT_SEND_CHALLENGE_ERROR,
    INIT_USER_APPS,
    INIT_USER_APPS_ERROR,
    INIT_USER_APPS_SUCCESS,
    ON_BACK,
    ON_BACK_TWO_STEPS,
    ON_NEXT,
    ON_BACK_AUTHENTICATORS,
    ON_FINISH,
    ON_WELCOME_NEXT,
    QR_CODE_CANNOT_SCAN,
    QR_CODE_CANNOT_SCAN_NEXT,
    QR_CODE_NEXT,
    RESEND_CODE,
    RESEND_CODE_ERROR,
    RESEND_CODE_SUCCESS,
    SESSION_TIMEOUT,
    SET_AUTHENTICATOR,
    SET_DEVICE_TYPE,
    SUBMIT_PASSWORD,
    SUBMIT_PASSWORD_ERROR,
    SUBMIT_PASSWORD_SUCCESS,
    SUBMIT_VERIFICATION,
    SUBMIT_VERIFICATION_ERROR,
    SUBMIT_VERIFICATION_SUCCESS,
    VERIFY_AUTHENTICATOR_CODE,
    VERIFY_AUTHENTICATOR_CODE_ERROR,
    VERIFY_AUTHENTICATOR_CODE_SUCCESS,
    AFTER_VERIFY_AUTHENTICATOR_CODE_SUCCESS,
    GET_ACCOUNT_RECOVERY,
    GET_ACCOUNT_RECOVERY_SUCCESS,
    GET_ACCOUNT_RECOVERY_ERROR,
    ACCOUNT_RECOVERY_SELECTION,
    SETUP_RECOVERY_PHONE,
    SETUP_RECOVERY_PHONE_SUCCESS,
    SETUP_RECOVERY_PHONE_ERROR } from '../constants/registration'
import { isSessionTimedOut } from '../utils/app-context'


export const sessionTimeout = () => ({ type: SESSION_TIMEOUT })

export const validateActivationTokenInit = () => ({ type: INIT })
export const validateActivationTokenFailure = payload => ({ payload, type: FETCH_DATA_ERROR })
export const validateActivationTokenSuccess = payload => ({ payload, type: FETCH_DATA_SUCCESS })

export const onBack = () => ({ type: ON_BACK })
export const onBackTwoSteps = () => ({ type: ON_BACK_TWO_STEPS })
export const onNext = () => ({ type: ON_NEXT })
export const onWelcomeNext = () => ({ type: ON_WELCOME_NEXT })
export const onBackToAuthenticators = () => ({ type: ON_BACK_AUTHENTICATORS })

export const onFinish = () => ({ type: ON_FINISH })

export const initSendChallenge = () => ({ type: INIT_SEND_CHALLENGE })
export const initSendChallengeSuccess = payload => ({ payload, type: INIT_SEND_CHALLENGE_SUCCESS })
export const initSendChallengeFailure = payload => ({ payload, type: INIT_SEND_CHALLENGE_ERROR })

export const onResendCode = payload => ({ payload, type: RESEND_CODE })
export const resendCodeSuccess = payload => ({ payload, type: RESEND_CODE_SUCCESS })
export const resendCodeFailure = payload => ({ payload, type: RESEND_CODE_ERROR })

export const onSubmitVerification = payload => ({ payload, type: SUBMIT_VERIFICATION })
export const submitVerificationSuccess = payload => ({ payload, type: SUBMIT_VERIFICATION_SUCCESS })
export const submitVerificationFailure = payload => ({ payload, type: SUBMIT_VERIFICATION_ERROR })

export const onSubmitPassword = payload => ({ payload, type: SUBMIT_PASSWORD })
export const submitPasswordSuccess = payload => ({ payload, type: SUBMIT_PASSWORD_SUCCESS })
export const submitPasswordFailure = payload => ({ payload, type: SUBMIT_PASSWORD_ERROR })

export const initAuthenticators = () => ({ type: INIT_AUTHENTICATORS })
export const initAuthenticatorsSuccess = payload => ({ payload, type: INIT_AUTHENTICATORS_SUCCESS })
export const initAuthenticatorsFailure = payload => ({ payload, type: INIT_AUTHENTICATORS_ERROR })

export const onEnroll = () => ({ type: ENROLL_MFA })
export const onEnrollSuccess = payload => ({ payload, type: ENROLL_MFA_SUCCESS })
export const onEnrollFailure = payload => ({ payload, type: ENROLL_MFA_ERROR })

export const initEnrollFactor = payload => ({ payload, type: INIT_ENROLL_FACTOR })
export const initEnrollFactorSuccess = payload => ({ payload, type: INIT_ENROLL_FACTOR_SUCCESS })
export const initEnrollFactorFailure = payload => ({ payload, type: INIT_ENROLL_FACTOR_ERROR })

export const onSetAuthenticator = payload => ({ payload, type: SET_AUTHENTICATOR })
export const onSetDeviceType = () => ({ type: SET_DEVICE_TYPE })

export const onQRCodeNext = () => ({ type: QR_CODE_NEXT })
export const onQRCodeCannotScan = () => ({ type: QR_CODE_CANNOT_SCAN })
export const onQRCodeCannotScanNext = () => ({ type: QR_CODE_CANNOT_SCAN_NEXT })

export const onVerifyAuthenticatorCode = payload => ({ payload, type: VERIFY_AUTHENTICATOR_CODE })
export const onVerifyAuthenticatorCodeSuccess = payload => ({ payload, type: VERIFY_AUTHENTICATOR_CODE_SUCCESS })
export const onAfterVerifyAuthenticatorCodeSuccess = () => ({ type: AFTER_VERIFY_AUTHENTICATOR_CODE_SUCCESS })
export const onVerifyAuthenticatorCodeFailure = payload => ({ payload, type: VERIFY_AUTHENTICATOR_CODE_ERROR })

export const initUserApps = () => ({ type: INIT_USER_APPS })
export const initUserAppsSuccess = payload => ({ payload, type: INIT_USER_APPS_SUCCESS })
export const initUserAppsFailure = payload => ({ payload, type: INIT_USER_APPS_ERROR })

export const getAccountRecoveryInit = () => ({ type: GET_ACCOUNT_RECOVERY })
export const getAccountRecoverySuccess = payload => ({ payload, type: GET_ACCOUNT_RECOVERY_SUCCESS })
export const getAccountRecoveryError = payload => ({ payload, type: GET_ACCOUNT_RECOVERY_ERROR })

export const accountRecoverySelection = () => ({ type: ACCOUNT_RECOVERY_SELECTION })

export const validateActivationToken = activationToken => {
    return dispatch => {
        dispatch(validateActivationTokenInit())

        axios.get(routes.registration, { params: activationToken })
            .then(result => dispatch(validateActivationTokenSuccess(result.data.data)))
            .catch(err => dispatch(validateActivationTokenFailure(err.response.data.error)))
    }
}

export const welcomeNext = () => dispatch => dispatch(onWelcomeNext())

export const back = () => dispatch => dispatch(onBack())
export const backTwoSteps = () => dispatch => dispatch(onBackTwoSteps())
export const next = () => dispatch => dispatch(onNext())

export const sendChallenge = recoveryType => {
    return dispatch => {
        dispatch(initSendChallenge())

        axios.post(routes.sendChallenge, recoveryType)
            .then(result => dispatch(initSendChallengeSuccess(result.data.data)))
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout())
                }
                dispatch(initSendChallengeFailure(err.response.data.error))
            })
    }
}

export const resendCode = recoveryType => {
    return dispatch => {
        dispatch(onResendCode())

        axios.post(routes.sendChallenge, recoveryType)
            .then(() => dispatch(resendCodeSuccess()))
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout())
                }
                dispatch(resendCodeFailure(err.response.data.error))
            })
    }
}

export const submitVerification = passCode => {
    return dispatch => {
        dispatch(onSubmitVerification())

        axios.post(routes.verifyAccountRecovery, passCode)
            .then(result => dispatch(submitVerificationSuccess(result.data.data)))
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout())
                }
                dispatch(submitVerificationFailure(err.response.data.error))
            })
    }
}

export const setPassword = password => {
    return dispatch => {
        dispatch(onSubmitPassword())

        axios.post(routes.setPassword, password)
            .then(result => dispatch(submitPasswordSuccess(result.data.data)))
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout())
                }
                dispatch(submitPasswordFailure(err.response.data.error))
            })
    }
}

export const getAuthenticators = () => {
    return dispatch => {
        dispatch(initAuthenticators())

        axios.get(routes.getAuthenticators)
            .then(result => {
                const combinedData = result.data.data
                dispatch(initAuthenticatorsSuccess(combinedData))
            })
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout())
                }
                dispatch(initAuthenticatorsFailure(err.response?.data?.error))
            })
    }
}

export const backToAuthenticators = () => dispatch => dispatch(onBackToAuthenticators())

export const setAuthenticator = () => dispatch => dispatch(onSetAuthenticator())

export const setDeviceType = () => dispatch => dispatch(onSetDeviceType())

export const finish = () => dispatch => dispatch(onFinish())

export const enrollMFA = () => {
    return dispatch => {
        dispatch(onEnroll())

        axios.post(routes.enrollMFA)
            .then(result => dispatch(onEnrollSuccess(result.data.data)))
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout())
                }
                dispatch(onEnrollFailure(err.response.data.error))
            })
    }
}

export const enrollFactor = body => {
    return dispatch => {
        dispatch(initEnrollFactor())

        axios.post(routes.enrollFactor, body)
            .then(result => dispatch(initEnrollFactorSuccess(result.data.data)))
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout())
                }
                dispatch(initEnrollFactorFailure(err.response.data.error))
            })
    }
}

export const qrCodeNext = () => dispatch => dispatch(onQRCodeNext())

export const qrCodeCannotScan = () => dispatch => dispatch(onQRCodeCannotScan())

export const qrCodeCannotScanNext = () => dispatch => dispatch(onQRCodeCannotScanNext())
export const submitAfterVerifyAuthenticatorCodeSuccess = () => dispatch => dispatch(onAfterVerifyAuthenticatorCodeSuccess())

export const verifyAuthenticatorCode = body => {
    return dispatch => {
        dispatch(onVerifyAuthenticatorCode())

        axios.post(routes.activateFactor, body)
            .then(result => dispatch(onVerifyAuthenticatorCodeSuccess(result.data.data)))
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout())
                }
                dispatch(onVerifyAuthenticatorCodeFailure(err.response.data.error))
            })
    }
}

export const getLogins = () => {
    return dispatch => {
        dispatch(initUserApps())

        axios.get(routes.getLogins)
            .then(result => dispatch(initUserAppsSuccess(result.data.data)))
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout())
                }
                dispatch(initUserAppsFailure(err.response.data.error))
            })
    }
}

export const getAccountRecovery = body => {
    return dispatch => {
        dispatch(getAccountRecoveryInit())

        axios.post(routes.getAccountRecovery, body)
            .then(result => dispatch(getAccountRecoverySuccess(result.data.data)))
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout())
                }
                dispatch(getAccountRecoveryError(err.response.data.error))
            })
    }
}

export const onSetupRecoveryPhone = () => ({ type: SETUP_RECOVERY_PHONE })
export const onSetupRecoveryPhoneSuccess = payload => ({ payload, type: SETUP_RECOVERY_PHONE_SUCCESS })
export const onSetupRecoveryPhoneError = payload => ({ payload, type: SETUP_RECOVERY_PHONE_ERROR })

export const setupRecoveryPhone = body => {
    return dispatch => {
        dispatch(onSetupRecoveryPhone())

        axios.post(routes.setupRecoveryPhone, body)
            .then(result => {
                dispatch(onSetupRecoveryPhoneSuccess(result.data.data))
                // Refetch account recovery data to show the newly set up phone
                dispatch(getAccountRecoveryInit())
                axios.post(routes.getAccountRecovery, { oktaUserId: body.oktaUserId })
                    .then(res => dispatch(getAccountRecoverySuccess(res.data.data)))
                    .catch(err => dispatch(getAccountRecoveryError(err.response?.data?.error)))
            })
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout())
                }
                dispatch(onSetupRecoveryPhoneError(err.response?.data?.error))
            })
    }
}
